<template>
  <section>
    <div class="container-fluid">
      <div class="w80">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-5 ">
            <div class="video" v-if="activeVideo">
              <video-player v-if="item.entrada == 'Y'" class="vjs-custom-skin" ref="videoPlayer"
                :options="playerOptions"></video-player>
              <video-player v-else class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions"
                @ready="playerReadied"></video-player>
            </div>
            <div class="video touchpad"
              :style="{ 'background-image': 'url(' + thumb + ')', 'background-size': '100%', 'background-position': 'center' }"
              @click="playVideo" v-else>
              <button class="play-button secondary touchpad">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-play">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
              </button>
            </div><!-- video touchpad -->
            <div class="row actions align-items-center">
              <div class="col">
                <div class="button-container">
                  <button :class="['accion-video', { 'active': like }]">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
                    </svg>
                    <span></span>
                  </button>
                  <button :class="['accion-video', { 'active': dislike }]">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
                    </svg>
                    <span></span>
                  </button>
                  <button :class="['accion-video', { 'active': meh }]">
                    <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor" data-prefix="fas"
                      data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path
                        d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z">
                      </path>
                    </svg>
                    <span></span>
                  </button>
                </div><!-- button-container -->
              </div><!-- col -->
              <div class="col-auto">
                <div class="calificacion">
                  <div class="stars">
                    <label v-for="i in 4" :key="i" :class="stars[i - 1]">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path
                          d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" />
                      </svg>
                    </label>
                  </div><!-- stars -->
                </div><!-- calificacion -->
              </div><!-- col-auto -->
            </div><!-- row actions align-items-center -->
          </div><!-- col-sm-12 col-md-5-->
          <div class="col-sm-12 col-md-7">
            <div class="row align-items-center">
              <div class="col">
                <div class="user-avatar" v-if="item.noticiero">
                  <div class="img-avatar"
                    :style="{ 'background-image': 'url(' + item.noticiero.imagen + '),url(' + defaultImage + ')' }"></div>
                  <div class="data-avatar">
                    <p class="user-name touchpad noticieroName">{{ item.noticiero.nombre }}</p>
                    <p class="user">{{ item.nombre_canal }}</p>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <svg class="svgPD" v-if="item.entrada == 'T'" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30px" height="30px" viewBox="0 0 24 24">
                  <path
                    d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
                </svg>
                <svg class="svgPD" v-if="item.entrada == 'R'" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px"
                  height="30px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                  <path
                    d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
                </svg>
              </div>
            </div><!-- row align-items-center -->
            <div class="post-info">
              <div class="info-heading">
                <div class="row align-items-center">
                  <div class="col">
                    <h2 class="tiulo-post" v-html="convertString(item.titulo)"></h2>
                  </div> <!-- col -->
                </div> <!-- row align-items-center -->
              </div><!--info-heading-->
              <div class="content">
                <!--<p class="blanco" v-if="item.entrada!='T' && item.entrada!='R'">Publicado el {{parseFecha(item.publicado_utc)}}</p>-->
                <p v-html="item.nota"></p>
              </div><!-- content -->
            </div><!--post-info-->
            <div class="row" v-if="(item.entrada == 'T') || item.entrada == 'R'">

              <!-- <p class="col-4 touchpad link" @click="openAbstract" v-if="bandIA">
                Resumen
              </p> -->
              
              <p class="col-4 touchpad link" @click="openTranscription" v-if="bandIA">
                Resumen
              </p>
            </div>
            <div class="row " style="position:absolute;bottom:0;right:0;padding-right:15px;">
              <div class="button-container derecha">
                <button class="button small accion-video tooltip tooltip-top  blanco " data-tooltip="Descargar"
                  v-if="item.entrada != 'Y'" @click="download">
                  <font-awesome-icon icon="cloud-download-alt" style="color:#ebf9ff; height:15px" />
                </button>

                <!-- agregar botones -->
              </div>

            </div><!-- row actions align-items-center -->
          </div><!-- col-sm-12 col-md-7-->
        </div><!-- row -->
        <br>
        <div class="divider"></div>
        <div class="comentarios">
          <h2>Comentarios</h2>
          <div class="row">
            <div class="col-sm-12 col-md-6" v-if="comments.length > 0">
              <div class="noPadding noMargin" style="width:100%" v-for="comment in comments" :key="comment.key">

                <div class="inlineBlock noPadding noMargin" style="width:95%;">
                  <div v-html="convertString(comment.comentario)"></div>
                  <label class="sub">{{ getFecha(comment.created) }}</label>
                </div>

              </div>
            </div>
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6">
              <div class="button-circle-more secondary" v-if="LastEvaluatedKey">
                <button class="circle-more" @click="getComments">
                  <svg viewBox="0 0 18 18">
                    <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                      <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903" width="2" height="18"
                        rx="1" transform="translate(179 753)" fill="#fff" />
                      <rect id="Rectángulo_redondeado_903_copia" data-name="Rectángulo redondeado 903 copia" width="18"
                        height="2" rx="1" transform="translate(171 761)" fill="#fff" />
                    </g>
                  </svg>
                </button>
              </div>
              <!-- END BUTTON CIRCLE -->

            </div>

          </div>
        </div><!-- comments -->
        <div class="page-actions">
          <button class="button small outline" v-if="from2" @click="goBack">Regresar</button>
        </div>
      </div><!-- div w80-->
    </div>
    <div :class="['modal-container', { active: isAbstract }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news" style="max-width: 40%; height: 60%">
        <div class="title-card">
          <h4>Resumen</h4>
          <button class="touchpad" @click="closeModalRe">
            x
          </button>
        </div>
        <div class="card-content trascripcion">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark">
                {{ abstractTxt }}
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- div modal exportfile-->
    <!--modal TRANSCRIPCION de datos-->
    <div :class="['modal-container', { active: isTranscription }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news" style="max-width: 40%; height: 60%">
        <div class="title-card">
          <h4>Resumen</h4>
          <button class="touchpad" @click="() => {
            closeModalTr();
          }
            ">
            x
          </button>
        </div>
        <div class="card-content">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark" id="textoACopiartras">
                {{ trascriptionTxt }}
              </p>
            </div>
          </div>
          <div class="Keywords-button-container">
            <button style="background-color: #00b99e;" class=" button   tooltip tooltip-top"
              @click="() => { copiar('textoACopiartras') }"><font-awesome-icon icon="copy"
                style="color: #ebf9ff; height: 15px" /></button>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>


import mvideo from '@/components/mvideo'
import videojs from 'video.js'
window.videojs = videojs
require('videojs-contrib-hls/dist/videojs-contrib-hls')

import moment from 'moment-timezone'

import closeIcon from 'vue-material-design-icons/Close.vue';

import { strings } from "@/services/strings.js";

require("videojs-youtube/dist/Youtube");

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCloudDownloadAlt,
  faPaperPlane,
  faSave,
  faChevronDown,
  faFolderPlus,
  faComment,
  faTimes,
  faEdit,
  faCheck,
  faPhotoVideo,
  faCamera,
  faShareAlt,
  faCopy,
  faDownload,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
// import axios from 'axios'
library.add(faCloudDownloadAlt);
library.add(faPaperPlane);
library.add(faSave);
library.add(faChevronDown);
library.add(faFolderPlus);
library.add(faComment);
library.add(faTimes);
library.add(faEdit);
library.add(faCheck);
library.add(faPhotoVideo);
library.add(faCamera);
library.add(faShareAlt);
library.add(faCopy);
library.add(faDownload);
library.add(faRedoAlt);

export default {
  name: 'videoNote',
  components: { mvideo, closeIcon },
  props: ['item', 'from', 'fromParams', 'noStars', 'comments', 'params'],
  mixins: [strings],
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
  },
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      fuente_info: null,
      playerOptions: {
        // videojs and plugin options
        height: '100%',
        sources: [{
          withCredentials: false,
          type: "application/x-mpegURL",
          src: ""// "https://d8.bdtr.net/hls/notas.m3u8?c=DF_MEX-T4-20190308-2917-50718-179" //  this.playerOptions.sources[0].src = this.streams.hls
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false
        },
        flash: { hls: { withCredentials: false } },
        html5: {
          vhs: { withCredentials: false, overrideNative: true },
          hls: { withCredentials: false, overrideNative: true },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        poster: this.$store.state.defaultNote,
        autoplay: true
      },
      stars: ['star', 'star', 'star', 'star'],
      LastEvaluatedKey: null,
      activeVideo: false,
      defaultImage: "",
      from2: null,
      thumb: "",
      like: false,
      dislike: false,
      meh: false,
      media: '',
      bandIA: false,
      isAbstract: false,
      isTranscription: false,
      abstractTxt: '',
      trascriptionTxt: ''
    }
  },
  beforeMount() {

    console.log(this.token, "token", this.params);
    if (this.token) {
      this.validToken();

    }

    //de donde viene?
    var backData2 = this.$store.state.backData2;
    var d = backData2.length > 0 ? backData2[backData2.length - 1] : {};
    this.from2 = d.from;
    //this.fromParams = d.fromParams;
    this.extraParams = d.extraParams;
    var item = this.item;
    console.log(this.item);
    if (this.item.entrada == 'Y') {
      this.media = 'Youtube';
      this.item.descripcion = this.item.descripcion ? this.item.descripcion : "";
      var nota = this.item.descripcion.replace(/(?:\r\n|\r|\n)/g, '<br />');
      var parser = new DOMParser();
      var dom = parser.parseFromString('<!doctype html><body>' + nota, 'text/html');

      var decodedString = dom.body.innerHTML;
      console.log('decoded String', decodedString);

      this.defaultImage = this.$store.state.defaultYoutube;

      this.item.noticiero = {
        nombre: this.item.noticiero_nombre,
        imagen: this.item.noticiero_img
      };

      var id_arr = this.item.media.split('?');

      var id_arr2 = id_arr[1].split('=');
      var id = id_arr2[1]
      this.thumb = "https://img.youtube.com/vi/" + id + "/default.jpg";
      console.log(this.item)

      var fecha = this.getFecha(this.item.publicado_utc);
      var fecha_arr = fecha.split(' ');
      this.item.nota = 'Fecha: <strong>' + fecha_arr[0] + '</strong><br>';
      this.item.nota += 'Hora: <strong>' + fecha_arr[1] + '</strong><br><br>';

      if (decodedString != this.item.titulo)
        this.item.nota += decodedString;

      this.playerOptions = {
        height: "100%",
        sources: [{
          type: "video/youtube",
          src: this.item.media
        }],
        techOrder: ["youtube"],
        autoplay: true,
        responsive: true
      };
    }
    else {
      this.bandIA = this.item.abstract ? true : false;
      const originalString = this.item.claveorigen;
      const parts = originalString.split('-');
      const seconds = parseInt(parts[4]); // 29242
      const incrementValue = parseInt(parts[5]); // 84
      const newSeconds = seconds - 30;
      const newIncrement = incrementValue + 60;
      parts[4] = newSeconds.toString();
      parts[5] = newIncrement.toString();
      const newString = parts.join('-');
     
      this.playerOptions.sources[0].src = this.$store.getters.getVideoUrl + newString;

      //this.playerOptions.sources[0].src = this.$store.getters.getVideoUrl + this.item.claveorigen;
      this.defaultImage = this.item.entrada == 'T' ? this.$store.state.defaultTV : this.$store.state.defaultRadio;
      this.thumb = this.playerOptions.poster = this.item.thumb ? this.item.thumb : this.item.noticiero.imagen;
      var conductor = this.item.descripcion.conductor ? this.item.descripcion.conductor : "";
      var programa = this.item.descripcion.programa ? this.item.descripcion.programa : "";
      var inicio = this.item.descripcion.inicio ? this.item.descripcion.inicio : "";
      var dur = this.item.descripcion.duracion ? this.item.descripcion.duracion : "";
      var fecha = this.parseFecha(this.item.publicado_utc);
      var fecha_arr = fecha.split(' ');
      this.media = this.item.entrada == 'T' ? 'Televisión' : 'Radio';
      this.item.nota = '<p>Medio: <strong>' + this.media + '</strong><br>';
      this.item.nota += 'Conductor: <strong>' + conductor + '</strong><br>';
      this.item.nota += 'Fecha: <strong>' + fecha_arr[0] + '</strong><br>';
      this.item.nota += 'Hora de Inicio: <strong>' + fecha_arr[1] + '</strong><br>';

      //this.item.nota += 'Inicio: <strong>' + inicio + '</strong><br>';
      this.item.nota += 'Duración: <strong>' + dur + '</strong></p>';
      this.$nextTick(function () {
        this.$set(this.item, "nota", this.item.nota);
      });

    }



    if (this.item.metadatos) {
      var new_item = this.item.metadatos;
      if (new_item.titulo) {
        this.$nextTick(function () {
          this.$set(this.item, "titulo", new_item.titulo);
        });
      }

      if (new_item.descripcion) {
        this.$nextTick(function () {
          this.$set(this.item, "nota", new_item.descripcion);
        });
      }
      if (new_item.imagen) {
        this.thumb = new_item.imagen;
        this.playerOptions.poster = this.thumb;
      }

       if (new_item.claveorigen){
        const originalString1 = new_item.claveorigen;
        const parts1 = originalString1.split('-');
        const seconds1 = parseInt(parts1[4]); // 29242
        const incrementValue1 = parseInt(parts1[5]); // 84
        const newSeconds1 = seconds1 - 30;
        const newIncrement1 = incrementValue1 + 60;
        parts1[4] = newSeconds1.toString();
        parts1[5] = newIncrement1.toString();
        let newString1 = parts1.join('-');
        newString1 = newString1.split("&cut=")[0]
        this.playerOptions.sources[0].src = this.$store.getters.getVideoUrl + newString1;

      }

      
      this.setLikes(new_item.lke);
      this.noStars = new_item.stars;
      this.setStars();

    }
  },
  methods: {
    setStars() {
      var noStars = this.noStars;
      this.pintaStars(noStars);
    },
    pintaStars(noStars) {
      if (noStars != undefined) {
        this.resetStars();
        for (var i = 0; i < noStars; i++) {
          this.stars[i] += ' active';
        }
      }
    },
    resetStars() {
      this.stars = ['star', 'star', 'star', 'star'];
    },
    getFecha(fecha) {
      moment.tz.setDefault('America/Mexico_City');
      var tmp = moment(fecha);
      var f = moment.tz(tmp, 'America/Mexico_City').format('DD/MM/YYYY HH:mm:ss');
      return f;
    },
    setLike() {
      this.like = true;
      this.dislike = false;
      this.meh = false;
    },
    setDislike() {
      this.like = false;
      this.dislike = true;
      this.meh = false;
    },
    setMeh() {
      this.like = false;
      this.dislike = false;
      this.meh = true;
    },
    setLikes(type) {
      switch (type) {
        case 0: this.setDislike(); break;
        case 1: this.setLike(); break;
        case 2: this.setMeh(); break;
      }
    },
    playVideo() {
      this.activeVideo = true;
    },
    /*
    download() {
      console.log("store==>",this.$store.getters.getVideoUrl)
      console.log("store==>",this.$store.state.d8)
      var hst = this.$store.state.d8;
      var url = hst + "/hls/downloadNota.php?c=" + this.item.claveorigen;
      console.log(url);
      window.location = url;
    },*/
    download() {
      var self = this;
      var json = {
        input_file: this.item.claveorigen
      }

      axios.post(self.url + "invoqueCreateFile", json).then((response) => {
        console.log(response);
        // this.item.entrada
        if (response.data.success) {
            var redir = "https://newscastv2.s3.us-east-1.amazonaws.com/request.html?dato=" + encodeURIComponent(response.data.data)
            window.open(redir, '_blank');
        }

      });
    },
    goBack() {
      var backData2 = this.$store.state.backData2;

      var data = backData2.pop();

      if (data == undefined) {
        this.$router.back();
      }
      else {
        var from = data.from;
        var params = data.fromParams;

        if (from == 'publicNotas') {
          this.$router.back();
        } else {
          this.$router.push({
            name: from,
            params: params
          });
        }


      }
      /*switch(this.from){
          case 'folder':  this.$router.push({name:'public',params:{type:'folder', data:this.fromParams}}); break;
          case 'notas':  this.$router.push({name:'publicNotas',params:{from:this.fromParams.from,params:this.fromParams.params,query:this.fromParams.query}}); break;
      }*/
    },
    parseFecha(fecha) {//fecha= "2020-02-06 16:13:12"
      moment.tz.setDefault('America/Mexico_City');

      var tmp = moment(fecha);

      var f = moment
        .tz(tmp, "America/Mexico_City")

        .format("DD/MM/YYYY HH:mm:ss");
      return f;
    },
    // VIDEO PLAYER METHODS
    playerReadied(player) {
      var engine = player.tech_.hls || player.tech_.vhs
      if (engine && engine.xhr) {
        engine.xhr.beforeRequest = function (options) {
          return options
        }
      }
    },
    openAbstract() {
      this.abstractTxt = this.item.abstract ? this.item.abstract : 'No contiene resumen'
      this.isAbstract = true
    },
    openTranscription() {
      this.trascriptionTxt = this.item.abstract ? this.item.abstract : 'No contiene texto'
      this.isTranscription = true
    },
    closeModalRe() {
      this.isAbstract = false
    },
    closeModalTr() {
      this.isTranscription = false
    },
    copiar(id) {
      var elementoParaCopiar = document.getElementById(id);
      var textoACopiar = elementoParaCopiar.textContent || elementoParaCopiar.innerText;

      // Crea un elemento de entrada de texto temporal
      var inputTemporal = document.createElement("input");
      inputTemporal.value = textoACopiar;

      // Agrega el elemento temporal al DOM
      document.body.appendChild(inputTemporal);

      // Selecciona el texto dentro del elemento de entrada de texto
      inputTemporal.select();
      inputTemporal.setSelectionRange(0, 99999); // Para dispositivos móviles

      // Copia el texto al portapapeles
      document.execCommand("copy");

      // Elimina el elemento de entrada de texto temporal
      document.body.removeChild(inputTemporal);

      this.success("Copiado al portapapeles");
    },
    success(msg) {
      this.$snotify.clear();
      this.$snotify.success(msg, this.$store.state.success);
    },

    async validToken() {
      var json = {
        token: this.token,
        params: this.params
      }
      var entr = this.obtenerPagina(this.item.entrada);
      axios.post(this.url + "validaLoginUsuario", json).then((response) => {
        console.log(response);
        // this.item.entrada
        if (response.data.success) {
          var r = '/'+entr+'/' + this.item.entrada + '/' + response.data.data;
          console.log(r);
          this.$router.push(r);
        }

      });
    },

    obtenerPagina(med) {
      var name = '';
      switch (med) {
        case "T":
        case "R":
          name = "nota";
          break;
        case "Y":
          name = "notaYotube";
          break;
        case "FB":
        case "I":
        case "TW":
          name = "notaEmbedded";
          break;
        case "PD":
          name = "notaText";
          break;
        case "TK":
          name = "notaTk";
          break;
      }

      return name;
    }

  },

}
</script>


<style scoped>
.sub {
  color: #00b99e !important;
}

.specialPadding {
  padding: 8px 15px;
}

.calificacion .stars .star.active svg {
  fill: white;
}

.trascripcionR {
  width: 100%;
  /* Establece el ancho del div */
  height: 90%;
  /* Establece la altura del div */
  overflow: auto;
  /* Habilita la barra de desplazamiento si el contenido excede las dimensiones del div */
}
</style>



